import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-credit-card",
  "use": "icon-credit-card-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-credit-card\">\n  <path d=\"M928 256H96c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32z m-40 440H136V328h752v368z\" fill=\"currentColor\" p-id=\"13427\" />\n  <path d=\"M136 368h752v80H136zM180 630h168c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H180c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM404 630h200c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H404c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z\" fill=\"currentColor\" p-id=\"13428\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/credit-card.svg
// module id = igCf
// module chunks = 117